<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-10 0 310 300">
    <path
      fill="currentColor"
      d="M28 28q-3 2 -3 5.5t2 6.5l51 51q-18 13 -31 31.5t-18 40.5q-1 4 1 7.5t5.5 4.5t7 -1t4.5 -6q5 -20 16.5 -36t28.5 -27l22 23q-14 14 -14 34.5t14.5 35.5t35 15t35.5 -15l74 74q3 3 7 3t6.5 -2.5t2.5 -6t-2 -6.5l-128 -128v0l-104 -104q-3 -3 -7 -3t-6 3zM128 141l44 44
q-9 9 -22 9t-22 -9.5t-9 -22t9 -21.5zM150 69q-19 0 -36 5l15 16q11 -3 21 -3q37 0 65.5 23t37.5 58q1 4 4.5 6t7 1t5.5 -4.5t1 -7.5q-7 -27 -24.5 -48.5t-43 -33.5t-53.5 -12zM152 113l48 47q-1 -19 -14.5 -32.5t-33.5 -14.5z"
    />
  </svg>
</template>
